// web/src/tiferet/Glow.tsx — הזוהר של תפארת (29.09 ערב).
// 📄 מוטי 29.09: "במקום כדור חלקיקים — אפקט אחר. משהו עם קרני אור זהובות, אפקט של קדושה וזוהר."
// 🔑 שלוש שכבות: קרניים ארוכות שמסתובבות לאט · קרניים דקות ובהירות בכיוון ההפוך (נצנוץ) · לב של אור לבן-זהוב שנושם.
//    כשתפארת מדברת — הקרניים מאיצות והלב פועם. ⛔ תנועה למי שביקשה פחות תנועה במכשיר (prefers-reduced-motion).
// 🔑 CSS בלבד (tiferet.css) — ⛔ קנבס, ⛔ תמונות: קל, חד בכל גודל, ונעלם מצילומי מסך (tf-ui).
// 🆕 30.09 — "hd": השמש בצד ימין של ההדר (הכדור "עובר" לחלון כשהוא פתוח) · "stage": השמש הגדולה בבמה של ההצגה העצמית.
export function Glow({ size, speaking = false }: { size: "orb" | "head" | "hd" | "stage" | "mini"; speaking?: boolean }) {
  return (
    <span className={`tf-glow is-${size}${speaking ? " is-speaking" : ""}`} aria-hidden="true">
      <span className="tf-rays" />
      <span className="tf-core" />
    </span>
  );
}
